import Photo from "../commons/model/Photo";
import { StatusInfo } from "../reports/Report";
import UserInfo from "../commons/model/UserInfo";
import Answer from "../commons/model/Answer";

export default interface ReportTroubleshoot {
  creation: ReportStep;
  upload: ReportStep;
  processing: ReportStep;
  statusInfo: StatusInfo;
  patientInfo: UserInfo;
  assignmentInfo: UserInfo;
  analysis?: Analysis;
  technicalErrorMsg?: string;
  uploadedPhotos: { [mouthType: string]: PhotoSet };
  cancelUrl?: string;
  events: Event[];
  metadata?: Map<string, string>;
  isRead: Boolean;
  patientAnswers: Answer[];
  patientFileUrl: string;
}

export enum PhotoSetStatus {
  RECEIVED = "RECEIVED",
  PROCESSED = "PROCESSED",
  UPLOADING = "UPLOADING",
  REJECTED = "REJECTED",
  ANALYSING = "ANALYSING",
}

export enum MouthType {
  OPENED = "OPENED",
  SLIGHTLY_OPENED = "SLIGHTLY_OPENED",
  CLOSED = "CLOSED",
}

export interface PhotoSet {
  photos: Photo[];
  date?: string;
  status?: PhotoSetStatus;
  detail?: string;
}

export interface ReportStep {
  completionDate: string;
  status: StepStatus;
  type: StepType;
}

export interface Event {
  name: string;
  date: string;
  description: string;
  uri: string;
}

export enum StepType {
  CREATION = "CREATION",
  UPLOADING = "UPLOADING",
  ANALYSING = "ANALYSING",
}

export enum StepStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export interface Analysis {
  uid: string;
  href: string;
}

export function getPhotoSetStatusTypeStyle(s: PhotoSetStatus) {
  switch (s) {
    case PhotoSetStatus.UPLOADING:
    case PhotoSetStatus.ANALYSING:
      return "warning";
    case PhotoSetStatus.RECEIVED:
    case PhotoSetStatus.PROCESSED:
      return "success";
    case PhotoSetStatus.REJECTED:
      return "danger";
  }
}

export const getPhotoSetStatusTypeI18nKey = function (status: PhotoSetStatus) {
  switch (status) {
    case PhotoSetStatus.RECEIVED:
      return "Global.Status.received";
    case PhotoSetStatus.PROCESSED:
      return "Global.Status.processed";
    case PhotoSetStatus.UPLOADING:
      return "Global.Status.uploading";
    case PhotoSetStatus.ANALYSING:
      return "Global.Status.analysing";
    case PhotoSetStatus.REJECTED:
      return "Global.Status.rejected";
  }
};

export const getPhotoSetStatusIcon = function (status: PhotoSetStatus) {
  switch (status) {
    case PhotoSetStatus.UPLOADING:
      return "ic_upload";
    case PhotoSetStatus.ANALYSING:
      return "ic_analysing";
    case PhotoSetStatus.RECEIVED:
    case PhotoSetStatus.PROCESSED:
      return "ic_check_circled";
    case PhotoSetStatus.REJECTED:
      return "ic_exclamation_circled";
    default:
      return "ic_question";
  }
};
